import {useEffect} from 'react';
import {WidgetProps} from '@wix/yoshi-flow-editor';
import {CheckoutControllerProps} from '../../../types/checkoutApp.types';

export const usePendingNavigationEmitter = (controllerProps: WidgetProps<CheckoutControllerProps>): void => {
  const pendingNavigationRequest = controllerProps?.navigationStore?.pendingNavigationRequest;

  useEffect(() => {
    if (!pendingNavigationRequest) {
      return;
    }
    window.parent?.postMessage(pendingNavigationRequest.message, '*');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingNavigationRequest?.requestId]);
};
